import { gql } from '@apollo/client';

export const CREATE_QUESTION = gql(/*GraphQL*/ `
mutation CreateQuestion($createQuestionInput: CreateQuestionInput!) {
  createQuestion(createQuestionInput: $createQuestionInput) {
    id
    prompt
    options {
      desc
      isAnswer
    }
    explanation
    tag
    label
  }
}`);
